import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import PrepareTrackingDataHelper from '@Services/PrepareTrackingDataHelper';
import TargetExtendedDetails from '@Components/Results/targets/TargetExtendedDetails';
import TargetBasicDetails from '@Components/Results/targets/TargetBasicDetails';
import TargetMostActiveSubstance from '@Components/Results/targets/TargetMostActiveSubstance';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

function Target({ metadata, target, zoom: zoomValue, context }) {
  const [targetDetailsExpanded, setTargetDetailsExpanded] = useState(false);

  const toggleTargetDetails = useCallback(() => {
    setTargetDetailsExpanded((prev) => !prev);
  }, []);

  const getTrackingAttrs = useCallback(() => {
    return {
      'data-click-delegation': 'true',
      'data-tracking': 'true',
      'data-tracking-context': context || get(metadata, 'context'),
      'data-tracking-preview': getValueByNs({ metadata }, 'metadata.isViewPreview'),
      ...PrepareTrackingDataHelper.prepare(target),
    };
  }, [context, metadata, target]);

  const zoom = metadata.isViewPreview ? 0 : zoomValue;

  return (
    <div className="rx-element-content">
      <div className="clearfix rx-element--target__wrapper">
        <TargetBasicDetails
          metadata={metadata}
          target={target}
          detailsExpanded={targetDetailsExpanded}
          onDetailsToggle={toggleTargetDetails}
          trackingAttrs={getTrackingAttrs()}
        />
        <TargetMostActiveSubstance metadata={metadata} target={target} zoom={zoom} />
      </div>
      {targetDetailsExpanded && (
        <TargetExtendedDetails
          metadata={metadata}
          target={target}
          onDetailsToggle={toggleTargetDetails}
          trackingAttrs={getTrackingAttrs()}
        />
      )}
    </div>
  );
}

Target.propTypes = {
  metadata: MetadataPropTypesShape,
  target: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  context: PropTypes.string,
};

export default Target;
